/** Trotro slogans painted on the side and stickered on the back window. */
export const TROTRO_SLOGANS = [
  'GOD NEVER FAILS', 'SEA NEVER DRY', 'NO WEAPON FORMED', 'STILL HUSTLING', 'OBI NNIM OBI',
  'NYAME NHYIRA', 'EBENEZER', 'SAY NO TO JEALOUSY', 'ENEMIES ARE NOT HAPPY', 'FEAR WOMEN',
  'ONYAME BEKYERE', 'PSALM 23', 'AWURADE KASA', 'NO KING AS GOD', 'SHOW ME YOUR FRIENDS',
] as const;

export const WINDSCREEN_BANNERS = ['GOD IS KING', 'JESUS IS LORD', 'ALLAHU AKBAR', 'NYAME ADOM', 'BLOOD OF JESUS', 'ABBA FATHER'] as const;

/** Trotros: mostly white or silver, with gradient-style stripes. */
export const TROTRO_BODIES = ['#f4f4f1', '#e9eaec', '#d7d9dc', '#f2efe6', '#fff7e0'] as const;

export const TROTRO_STRIPE_SETS: readonly (readonly string[])[] = [
  ['#ce1126', '#fcd116', '#006b3f'],
  ['#1d3557', '#457b9d'],
  ['#e85d04', '#faa307'],
  ['#6a040f', '#d00000'],
  ['#2d6a4f', '#95d5b2'],
  ['#3a0ca3', '#4cc9f0'],
];

export const SLOGAN_COLORS = ['#c1121f', '#1d3557', '#2d6a4f', '#6a040f', '#3a0ca3'] as const;

/** Accra taxis: any body colour, with the corner panels painted yellow-orange. */
export const TAXI_BODIES = ['#f1f1f1', '#b8bcc2', '#1f2a44', '#8d0801', '#2b2d42'] as const;
export const TAXI_CORNERS = '#f4a019';

export const CAR_BODIES = ['#f5f5f5', '#c0c4c9', '#1b1b1e', '#7d8597', '#0b3954', '#9d0208', '#e9ecef'] as const;
export const TRUCK_BODIES = ['#1d4e89', '#e9ecef', '#bc4749'] as const;
export const PRAGYA_BODIES = ['#f77f00', '#fcbf49', '#2a9d8f', '#d62828'] as const;

/** Ghana plates look like "GR 2468-24": region letters, numbers, year. */
export const PLATE_REGIONS = ['GR', 'GR', 'GR', 'GT', 'GE', 'GN', 'AS', 'GW'] as const;
